/**
 * ****************************************************************************
 * @description     :   Export all midleware function of saga
 * @created at      :   2022/07/13
 * @created by      :   
 * @package         :   dailyreportsystem
 * @copyright       :   Copyright (c)
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * imprt libraries
 */
import { all } from 'redux-saga/effects';

/**
 * impoprt saga of other components
 */
import AppSagas from './app/saga';
import ReportSagas from './report/saga';

/**
 * Fork all function in saga midleware
 * -----------------------------------------
 * @author : QuanHVM - 2022/07/19 - create
 * @access : public
 */
export default function* rootSaga () {
    yield all([
        AppSagas(),
        ReportSagas()
    ]);
}